class MedicalHistoryNutrition {
    public CalciumAdequate?: boolean;
    public VitaminDAdequate?: boolean;
    public FolicAcidPreconception?: boolean;
    public PrenatalVitamin?: boolean;
    public FoodAccessOrQualityAdequate?: boolean;
    public DietaryRestrictions?: boolean;

    constructor(fields?: Partial<MedicalHistoryNutrition>) {
        Object.assign(this, fields);
    }

    public setEmptyFieldsAsNo(): void {
        this.CalciumAdequate = this.CalciumAdequate || false;
        this.VitaminDAdequate = this.VitaminDAdequate || false;
        this.FolicAcidPreconception = this.FolicAcidPreconception || false;
        this.PrenatalVitamin = this.PrenatalVitamin || false;
        this.FoodAccessOrQualityAdequate = this.FoodAccessOrQualityAdequate || false;
        this.DietaryRestrictions = this.DietaryRestrictions || false;
    }
}

export { MedicalHistoryNutrition };
